import http from '@/common/utils/http-common';
import Tenant from '@/types/Tenant.type';

class TenantService {

  getAll() {
    return http.get('/tenants');
  }

  get(id: string | number) {
    return http.get(`/tenants/${id}`);
  }

  create(data: Tenant) {
    return http.post('/tenants', data);
  }

  update(data: Tenant, id: any) {
    return http.put(`/tenants/${id}`, data);
  }

}

export default new TenantService();
